import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import {
  Platform,
  ToastController,
  MenuController,
  NavController,
} from "@ionic/angular";
import { BehaviorSubject } from "rxjs";
import { ApiService } from "./api.service";
import { UtilserviceService } from "./utilservice.service";
import { environment } from "src/environments/environment";
import { ProfileService } from "./profile.service";
import { NavigationService } from "./navigation.service";
@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  authState = new BehaviorSubject(false);
  email: string;
  password: string;
  data: any;

  constructor(
    private router: Router,
    private storage: Storage,
    private platform: Platform,
    public toastController: ToastController,
    private api: ApiService,
    private util: UtilserviceService,
    private menu: MenuController,
    private navCtrl: NavController,
    private profileService: ProfileService,
    private nav: NavigationService
  ) {
    this.platform.ready().then(() => {
      this.ifLoggedIn();
    });
  }

  ifLoggedIn() {
    const token = localStorage.getItem("xtoken");
    if (token) {
      this.authState.next(true);
    } else {
      this.authState.next(false);
    }
  }

  login() {
    //console.log("login");
  }

  logout() {
    
    this.removeAllLocalStorage();
    this.menu.close();
    this.nav.home();
    this.authState.next(false);
    
    this.profileService.clearProfile();
  }

  isAuthenticated() {
    return this.authState.value;
  }

  removeAllLocalStorage() {
    localStorage.removeItem("xtoken");
    localStorage.removeItem(environment.xToken);
    localStorage.removeItem(environment.xrefreshToken);
    localStorage.removeItem("pushTokn");
    localStorage.removeItem("hasReturnUrl");
    localStorage.removeItem("returnUrl");
    localStorage.removeItem("booking-detail");
    localStorage.removeItem("dataofaddress");
  }
}
